import { Component, inject } from "@angular/core";
import { ITransactionGroup } from "@tylertech/tyler-api-types";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
export interface AddAdjustmentDialogData
{
    readonly itemId: string;
    readonly transaction: ITransactionGroup;
}
@Component({
    selector: "add-adjustment-dialog-component",
    templateUrl: "./addAdjustmentDialog.tmpl.html",
    standalone: false
})
export class AddAdjustmentDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<AddAdjustmentDialogComponent>>(MatDialogRef);
    private readonly data = inject<AddAdjustmentDialogData>(MAT_DIALOG_DATA);


    get itemId(): string
    {
        return this.data.itemId;
    }

    get transaction(): ITransactionGroup
    {
        return this.data.transaction;
    }
}
